import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { get, indexOf } from "lodash";
import { Col, Row, Typography } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import "./Home.css";
import { showAlertHome } from "../../utils/utilities";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => get(state.userInfoDuck, "userInfo", {}));
  useEffect(() => {
    if (indexOf(userInfo.roles, "MASTER") !== -1) {
      navigate("/choose-user");
    }
  }, [userInfo]);
  return (
    <div className="home-container">
      <Row justify="center">
        <Col className="center">
          <Title level={2}>
            {t("general.Welcome")} {userInfo.name}
          </Title>
        </Col>
      </Row>

      {userInfo.roles.map((r, i) => (
        <Row key={i} justify="center" align="middle" className="mb-1em">
          <Col className="mb-1em" span={22}>
            <strong>{t(`roles.${r}_title`)}</strong> - {t(`roles.${r}_desc`)}
          </Col>
          <Col className="center mb-1em" span={2}>
            <WarningOutlined
              hidden={showAlertHome(userInfo.info, r) === -1}
              className="PFred icon-large noCursorPointer"
            />
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default Home;
